import { render, staticRenderFns } from "./AssignaturesSelector2.vue?vue&type=template&id=ad6f95a2&scoped=true"
import script from "./AssignaturesSelector2.vue?vue&type=script&lang=js"
export * from "./AssignaturesSelector2.vue?vue&type=script&lang=js"
import style0 from "./AssignaturesSelector2.vue?vue&type=style&index=0&id=ad6f95a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6f95a2",
  null
  
)

export default component.exports